import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";

export default function RHFTextField({
  name,
  label,
  placeholder,
  rules,
  multiline = false,
  rows,
  size='small',
  sx,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          label={label}
          placeholder={placeholder}
          multiline={multiline}
          rows={rows}
          error={!!error}
          helperText={error?.message}
          size={size}
          sx={{
            // "& .MuiInputBase-input": { color: "white" },
            // "& label": { color: "#b0b8c4" },
            // "& label.Mui-focused": { color: "#90caf9" },
            // "& .MuiOutlinedInput-root fieldset": { borderColor: "#30455f" },
            // "& .MuiOutlinedInput-root:hover fieldset": { borderColor: "#90caf9" },
            // "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#1f6feb" },
            ...sx,
          }}
          {...other}
        />
      )}
    />
  );
}
